import React from 'react';
import { Table as AntdTable } from 'antd';
import styled, { css } from 'styled-components';

const FirstColumnStyle = css`
    font-weight: bold;
`;

const ClaStyledTable = styled(AntdTable)`
    thead > tr > th span {
        color: #999;
        text-transform: uppercase;
        font-size: 0.8em;
    }

    thead > tr > th {
        background: #fff;
        border-top: ${props => (props.bordered ? '' : '1px solid #efefef')};
    }

    tr td:first-child,
    tr td:first-child * {
        ${props => !props.rowSelection && FirstColumnStyle};
    }

    tr td:nth-child(2),
    tr td:nth-child(2) * {
        /* if we have rowSelection or expandRow as first column */
        ${props =>
            (props.rowSelection || props.expandedRowRender) &&
            FirstColumnStyle};
    }

    .ant-table-pagination {
        padding-right: 20px;
    }

    .ant-table-column-sort,
    .ant-table-thead > tr > th.ant-table-column-sort {
        background: transparent;
    }

    th.ant-table-column-sort span {
        text-decoration: underline;
        text-underline-position: under;
        font-weight: 700;
    }
`;

class Table extends AntdTable {
    render() {
        const { props } = this;
        return <ClaStyledTable {...props} />;
    }
}

export default Table;
